module.exports = __webpack_public_path__ + "static/media/Playground 3.46916ec8.svg";